'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('quickbooks-import', {
      url: '/admin/import/quickbooks',
      template: '<quickbooks-import></quickbooks-import>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/import/quickbooks/quickbooks-import.routes.js